export const TEXTS = {
  VIEW_BAG: 'View bag',
  ADD_TO_BAG: 'Add to Bag',
  ADDED_TO_CART: 'Item added to bag',
  ADD_TO_CART_ERROR: 'Something went wrong. Make it yours by trying once again!',
};
